module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/365.9f87004e.png";